module.exports = __webpack_public_path__ + "static/cheese-lg-5f7fc9ab7fbb86795d05c36d13ee121e.jpg";